const BASE = import.meta.env.VITE_API_URL ?? "/api/v1";
const CLE_JETON = "sfs.jeton";

export class ErreurApi extends Error {
  constructor(readonly statut: number, message: string, readonly code = "ERREUR", readonly details?: unknown) {
    super(message);
  }
}

export const jeton = {
  lire: () => localStorage.getItem(CLE_JETON),
  ecrire: (v: string) => localStorage.setItem(CLE_JETON, v),
  effacer: () => localStorage.removeItem(CLE_JETON)
};

async function requete<T>(chemin: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${BASE}${chemin}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(jeton.lire() ? { authorization: `Bearer ${jeton.lire()}` } : {}),
      ...init?.headers
    }
  });

  if (r.status === 401) {
    jeton.effacer();
    window.location.href = "/connexion";
    throw new ErreurApi(401, "Session expirée");
  }
  if (r.status === 204) return undefined as T;

  const corps = await r.json().catch(() => ({}));
  if (!r.ok) throw new ErreurApi(r.status, corps.message ?? "La requête a échoué", corps.code, corps.details);
  return corps as T;
}

export const api = {
  get:   <T>(c: string) => requete<T>(c),
  post:  <T>(c: string, corps?: unknown) => requete<T>(c, { method: "POST", body: JSON.stringify(corps ?? {}) }),
  put:   <T>(c: string, corps?: unknown) => requete<T>(c, { method: "PUT", body: JSON.stringify(corps ?? {}) }),
  patch: <T>(c: string, corps?: unknown) => requete<T>(c, { method: "PATCH", body: JSON.stringify(corps ?? {}) }),

  /** Téléchargement en flux : un export de 50 000 lignes ne passe pas par JSON. */
  async telecharger(chemin: string, corps: unknown, nomFichier: string) {
    const r = await fetch(`${BASE}${chemin}`, {
      method: "POST",
      headers: { "content-type": "application/json", authorization: `Bearer ${jeton.lire() ?? ""}` },
      body: JSON.stringify(corps)
    });
    if (!r.ok) throw new ErreurApi(r.status, "L'export a échoué");
    const blob = await r.blob();
    const lien = document.createElement("a");
    lien.href = URL.createObjectURL(blob);
    lien.download = nomFichier;
    lien.click();
    URL.revokeObjectURL(lien.href);
  }
};
